// Registro oficial de comunas sobre TanStack Query. Mismo patrón que
// `hooks/useInformes.ts`, con una diferencia: acá no hay mutaciones que
// invalidar, porque la tabla la escribe un seeder y nadie más.

import { useQuery } from "@tanstack/react-query";

import { fetchComunas } from "@/lib/comunas";

export const COMUNAS_KEY = ["comunas"] as const;

/**
 * Las 346 comunas del país, pedidas UNA vez por sesión.
 *
 * `staleTime: Infinity` y no los 5 minutos de los otros catálogos: el resto son
 * maestros que un administrador edita desde una pantalla, así que conviene que
 * envejezcan; este no tiene mantenedor. Cambia cuando se publica un decreto,
 * que llega por despliegue. Revalidarlo cada cinco minutos sería tráfico para
 * confirmar que la división política de Chile sigue igual.
 *
 * Con la respuesta en cache, el selector filtra en memoria y responde en la
 * tecla — que es todo el motivo de traer el maestro entero de una vez.
 */
export function useComunas() {
  return useQuery({
    queryKey: COMUNAS_KEY,
    queryFn: fetchComunas,
    staleTime: Infinity,
  });
}
